import {
    EXITS_ROUTE,
    EXITS_HATCH_ROUTE
} from './constants';

import http from '../../../utils/httpService';

/**
 *
 * @param quizID
 */
const requestStatisticsExits = ( quizID, params ) => {
    const route = params ? EXITS_ROUTE + '/' + quizID + params : EXITS_ROUTE + '/' + quizID;
    return http.request( route, 'GET' );
};
/**
 *
 * @param hatchID
 * @returns {*}
 */
const requestHatchStatisticsExits = ( hatchID ) => {
    const route = EXITS_HATCH_ROUTE + '/' + hatchID + '/questions';
    return http.request( route, 'GET' );
};

const requestHatchStatisticsExitsParams = ( hatchID, params ) => {
    const route = EXITS_HATCH_ROUTE + '/' + hatchID + '/questions'+params;
    return http.request( route, 'GET' );
};

export {
    requestStatisticsExits,
    requestHatchStatisticsExits,
    requestHatchStatisticsExitsParams
};